<template>
  <v-container
    fluid
    grid-list-md
    class="pt-2"
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Проходы через турникет {{schoolid}}</h2>
          <v-spacer></v-spacer>
          <v-autocomplete
            v-model="iPosition"
            :items="positions"
            :label="person ? 'Выбранный класс/должность' : 'Начните вводить класс'"
            item-value="positionid"
            item-text="name"
            hide-details
            clearable
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
          v-model="person"
          :label="person ? 'Выбранный пользователь' : 'Начните вводить ФИО'"
          :items="persons"
          item-text="fullname"
          return-object
          clearable
          dense
          hide-details
          class="mx-3"
          style="max-width: 400px"
          ></v-autocomplete>

          <v-menu
          bottom
          :close-on-content-click="false"
          :return-value.sync="date"
          offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
              style="max-width: 200px"
              v-model="day"
              label="Выберите дату"
              prepend-icon="event"
              readonly absolute
              v-on="on"
              hide-details
              class="mx-3"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              landscape
              locale="ru"
              first-day-of-week="1"
              width="600"
              @input="setDay()"
            >
            </v-date-picker>
          </v-menu>

          <v-btn class="mx-3" text icon color="secondary" @click=";fetch()">
            <v-icon>replay</v-icon>
          </v-btn>

        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table
          :headers="headers"
          :items="events"
          :loading="loading"
          :options.sync="options"
          :server-items-length="total"
          class="elevation-0"
          item-key="eventid"
          no-data-text="пусто"
          no-results-text="ничего не найдено"
          loading-text="идет загрузка"
          disable-pagination
          dense
          flat
          :footer-props="{
            showFirstLastPage: true,
            itemsPerPageOptions: [ 10, 20, 30, 50, 100],
            itemsPerPageText: 'Показывать:',
          }"
        >
          <template v-slot:item.originalts="{ item }">
            {{ dateFormat(item.originalts) }}
          </template>
          <template v-slot:item.direction="{ item }">
            <div :class="style(item)">
              {{ item.direction }}
            </div>
          </template>
          <template v-slot:item.person.fullname="{ item }">
            <span v-if="item.person"
            class="primary--text text--darken-3"
            style="cursor: pointer; font-size: 14px"
            @click="page = 1; person = item.person;"
            >{{ item.person.fullname }}
            </span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <DialogPersonEvents :person="person" v-model="dialog"></DialogPersonEvents>
  </v-container>
</template>

<script>
import moment from 'moment'
import DialogPersonEvents from '@/components/DialogPersonEvents.vue'
export default {
  name: 'Passages',
  components: {
    DialogPersonEvents
  },
  data: () => ({
    events: [],
    positions: [],
    options: {
      page: 1,
      itemsPerPage: 20,
    },
    total: 0,
    loading: false,
    person: null,
    headers: [
      { text: 'место', value: 'controllername', width: '200', sortable: false },
      { text: 'карта', value: 'cardid', width: '100', sortable: false },
      { text: 'напр.', value: 'direction', width: '100', sortable: false },
      { text: 'время', value: 'originalts', width: '100', sortable: false },
      { text: 'должность', value: 'person.positionname', width: '150', sortable: false },
      { text: 'ФИО', value: 'person.fullname', sortable: false },
    ],
    dialog: false,
    date: moment().format('YYYY-MM-DD'),
    day: moment().format('YYYY-MM-DD'),
    iPosition: null
  }),
  methods: {
    async fetch () {
      try {
        await Promise.all([
          this.$store.dispatch('fetchPersons'),
          this.$store.dispatch('fetchGuests'),
          this.fetchEvents(),
          this.fetchPositions()
        ])
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchEvents () {
      try {
        this.loading = true
        // eslint-disable-next-line
        const { meta, events, pages, total } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-events',
          pl: {
            person: this.iPosition ? null : this.person,
            start: this.day,
            end: moment(this.day).add(1, 'days').format('YYYY-MM-DD'),
            page: this.options.page,
            limit: this.options.itemsPerPage,
            orderby: 'originalts',
            order: 'desc',
            positionid: this.iPosition,
            withPersons: true
          }
        })
        this.total = parseInt(total)
        this.events = events
        this.pages = pages
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.loading = false
      }
    },
    async fetchPositions () {
      try {
        this.loading = true
        const { meta, positions } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-positions',
          pl: {}
        })
        this.$store.dispatch('snack', meta)
        this.positions = positions
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.loading = false
      }
    },
    setDay () {
      this.page = 1
      this.day = moment(this.date).format('YYYY-MM-DD')
      this.fetch()
    },
    dateFormat (date) {
      return moment(date).format('HH:mm:ss')
    },
    style (item) {
      if (item.direction === 'вход') return 'in'
      if (item.direction === 'выход') return 'out'
      if (item.direction === 'проход') return 'pass'
      return item.direction
    },
    openDialog () {
      if (this.person) {
        this.dialog = true
      }
    },
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
    schoolid () {
      return this.profile ? this.profile.schoolid : null
    },
    persons () {
      return [...this.$store.state.persons, ...this.$store.state.guests]
    },
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    person (val) {
      this.openDialog(val)
    },
    dialog (val) {
      if (!val) {
        this.person = null
      }
    },
    options: {
      handler () {
        if (this.profile) this.fetch()
      },
      deep: true,
    },
    iPosition (val) {
      this.fetchEvents()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
.in {
  background-color: rgba(50, 250, 70, 0.2)
}
.out {
  background-color: rgba(255, 143, 129, 0.2)
}
.pass {
  background-color: rgba(253, 242, 107, 0.3)
}
</style>
